import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
    providedIn: 'root',
})
export class CodeChallengeService {
    private CODE_VERIFIER_KEY = 'code_verifier';

    generateCodeVerifier(): string {
        const array = new Uint32Array(32);
        window.crypto.getRandomValues(array);
        return Array.from(array, (dec) => ('0' + dec.toString(16)).substr(-2)).join('');
    }

    storeCodeVerifier(verifier: string): void {
        localStorage.setItem(this.CODE_VERIFIER_KEY, verifier);
    }

    async generateCodeChallenge(verifier: string): Promise<string> {
        // Usando CryptoJS para gerar o hash
        const hash = CryptoJS.SHA256(verifier);
        const base64Digest = hash.toString(CryptoJS.enc.Base64)
            .replace(/\+/g, '-')
            .replace(/\//g, '_')
            .replace(/=+$/, '');
        return base64Digest;
    }

    getCodeVerifierKey(): string {
        return this.CODE_VERIFIER_KEY;
    }
}